<script setup lang="ts">
import { inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { DIRECT_MESSAGE } from '@/shared/constants/Links';
import { useBaseProfileStore } from '@/shared/stores/BaseProfileStore';
import { useGoogleAnalytics } from '@/shared/composables/googleAnalytics';
import { GA_ATRIBUTES } from '@/shared/constants/GoogleAnalytics';
import { useSettingsStore } from '@/shared/stores/SettingsStore';

const { t } = useI18n();
const { uri } = useBaseProfileStore();
const { canReceiveMessages } = useSettingsStore();
const { dataAttributesGA, updateAttributeGA } = useGoogleAnalytics();

const directMessageSourceType = inject('direct-message-source-type');

onMounted(() => {
  updateAttributeGA({
    [GA_ATRIBUTES.LABEL]: t('eventLabelProfile'),
    [GA_ATRIBUTES.ACTION]: t('eventActionClickMessageSentButton'),
  });
});
</script>

<template>
  <a
    v-if="canReceiveMessages"
    data-test-id="button-direct-message"
    :href="`${uri}${DIRECT_MESSAGE}${directMessageSourceType}`"
    class="flex items-center h-0 anw-primary-link !text-white anw-btn !no-underline grow md:grow-0 md:max-lg:w-fit"
    :title="t('sidebarContact')"
    v-bind="dataAttributesGA">
    {{ t('sidebarContact') }}
  </a>
</template>
